import { useContext } from 'react';
import { Icon } from '@iconify/react';
import { Card } from '../../../card/card';
import { Link, useNavigate } from 'react-router-dom';
import styles from './styles.module.css';
import { AppSettings } from '@config/app-settings';
import { useTranslation } from 'react-i18next';
import useListApplications from '@hooks/Applications/useListApplications';
import { MODULE_BASE, type ModuleCode } from '@modules/moduleRegistry';

const { appsCardHover } = styles;

interface Props {
  onClose: () => void;
}

const AppsGrid = ({ onClose }: Props) => {
  const ListApplications = useListApplications();
  const context = useContext(AppSettings);
  const navigate = useNavigate();
  const { t } = useTranslation();

  // المصدر الوحيد للحقيقة هو الراوتر/الكونتكست
  const currentSystem = (context?.sysCode as string) || '';

  // const changeSystem = (code: string) => {
  const changeSystem = (code: string, appName: string) => {
    const target = MODULE_BASE[code as ModuleCode] || '/';

    // تحديث عنوان التبويب فور النقر على النظام الجديد
    document.title = `${appName} | NEATIX ERP`;

    // لا نحدّث sysCode يدويًا هنا — الهوك سيستنتجه من URL
    // لا من need لـ replace:true، عادي navigate عادي
    navigate(target, { replace: true });

    onClose();
  };

  return (
    <>
      <div className='mb-4 p-2 border border-theme d-flex justify-content-between align-items-center shadow rounded-2 '>
        <div className='d-flex align-items-center flex-grow-1 justify-content-center'>
          <i className='bi bi-grid fs-3 me-2 text-theme'></i>
          <h5 className='fw-bold text-center m-0'>{t('Applications')}</h5>
        </div>
        <button type='button' className='btn-close ' onClick={onClose}></button>
      </div>

      <div className='px-2'>
        <div className='row g-4 align-items-stretch'>
          {[
            ...ListApplications,
            {
              id: '',
              name: t('إدارة المهــام'),
              icon: 'mdi:checkbox-marked-circle-outline',
              color: '#607d8b',
              Code: 'TASK',
              active: false
            }
          ]
            ?.filter(f => f.Code !== 'USER' && f.active)
            ?.map((app, index) => {
              const target = MODULE_BASE[app.Code as ModuleCode] || '/';
              return (
                <div className='col-xl-2  col-lg-3 col-md-6 col-sm-6 col-12' key={index}>
                  <Link
                    to={target}
                    onClick={e => {
                      e.preventDefault();
                      // changeSystem(app.Code);
                      changeSystem(app.Code, app.name);
                    }}
                    className='text-decoration-none'
                  >
                    <Card
                      className={`h-100 d-flex flex-column justify-content-center align-items-center text-center p-3 flex-grow-1 ${appsCardHover} ${
                        currentSystem === app.Code ? 'border border-theme bg-theme bg-opacity-15' : ''
                      }`}
                    >
                      <Icon
                        className='iconify fs-30px'
                        icon={app.icon}
                        width='50'
                        height='50'
                        style={{ color: app.color }}
                        aria-label={app.name + ' icon'}
                      />

                      <h6 className='mt-3 small lh-lg'>{app.name}</h6>
                    </Card>
                  </Link>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default AppsGrid;
